<template>
    <ModalDialogContainer ref="modalContainer" v-model:display="displayStatus">
        <div class="modal-dialog modal-md" role="document" @click="stopPropagationEvent">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title">{{ title }}</div>
                    <button type="button" class="btn-close" :title="$t('Close')" @click="close"></button>
                </div>
                <div class="modal-body">
                    <p>{{ message }}</p>
                    <div v-if="danger" class="form-check form-switch">
                        <input class="form-check-input cursor-pointer" type="checkbox" role="switch" v-model="confirmed" />
                        <label>{{ $t("I understand that this is a destructive action with non-reversible effects.") }}</label>
                    </div>
                    <div v-if="showAgain" class="form-check form-switch d-flex">
                        <CustomCheck class="me-2" @click="showModal = !showModal"> </CustomCheck>
                        <label>{{ $t("Do not show this message again.") }}</label>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click="confirm" v-if="!danger && !simpleDelete">
                        <IconItem :icon="processedIcon" height="1.5em" /> {{ $t("Confirm") }}
                    </button>
                    <button type="button" class="btn btn-danger" @click="confirm" :disabled="!confirmed" v-if="danger">
                        <IconItem icon="mdi:trash-can" height="1.5em" /> {{ $t("Delete") }}
                    </button>
                    <button type="button" class="btn btn-danger" @click="confirm" v-if="simpleDelete">
                        <IconItem icon="mdi:trash-can" height="1.5em" /> {{ $t("Delete") }}
                    </button>
                    <button type="button" class="btn btn-cancel" @click="close">
                        {{ $t("Cancel") }}
                    </button>
                </div>
            </div>
        </div>
    </ModalDialogContainer>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useVModel } from "@/utils/v-model";
import CustomCheck from "@/components/utils/CustomizableCheck.vue";
import { saveIntoLocalStorage } from "@/utils/local-storage";

export default defineComponent({
    name: "ConfirmationModal",
    emits: ["update:display", "confirm"],
    components: {
        CustomCheck,
    },
    props: {
        display: Boolean,
        title: String,
        message: String,
        danger: Boolean,
        simpleDelete: Boolean,
        showAgain: Boolean,
        icon: {
            type: String,
            default: "mdi:check",
        },
    },
    setup(props) {
        return {
            displayStatus: useVModel(props, "display"),
        };
    },
    data: function () {
        return {
            confirmed: false,
            showModal: true,
            processedIcon: this.icon,
        };
    },
    methods: {
        close: function () {
            this.displayStatus = false;
        },

        escapeToClose: function (event) {
            if (event.key === "Escape") {
                this.close();
            }
        },

        stopPropagationEvent: function (e) {
            e.stopPropagation();
        },

        confirm: function () {
            if (this.showAgain && !this.showModal) {
                saveIntoLocalStorage("showConfirmModal", false);
            }
            this.$emit("confirm");
            this.close();
        },
    },
    mounted: function () {
        if (this.display) {
            this.$autoFocus();
        }
    },
    watch: {
        display: function () {
            if (this.display) {
                this.$autoFocus();
            }
        },
    },
});
</script>

<style></style>
